import 'isomorphic-fetch';
import baseFetch from '../baseFetch';
import legacyApiFetch from '../legacyApiFetch';
import config from '../../config';

export const fetchReport = spotId => baseFetch(`/kbyg/spots/reports?spotId=${spotId}`);

export const fetchNearbySpots = spotId => baseFetch(`/kbyg/spots/nearby?spotId=${spotId}`);

export const fetchBuoys = async (legacySpotId, units) => {
  const url = `${config.legacyApi}/mobile/nearby/${legacySpotId}?resources=buoy&unit=${units}`;
  const response = await fetch(url);
  const body = await response.json();
  if (response.status > 200) throw body;
  return body;
};

export const fetchIdealConditions = legacySpotId =>
  legacyApiFetch(`/mobile/report/${legacySpotId}`);



// WEBPACK FOOTER //
// ./src/common/api/spot.js